import React from 'react';
import { motion } from 'framer-motion';
import { GAtrack } from '../../Utils/tracking';
import { AppContext } from '../../App';

const Heat = ({ heat, activeHeat, setHeat, delay, category, config }) => {
  const context = React.useContext(AppContext);
  const animationConfig = context.config.animation;
  const status = heat.heat_status.active_status;

  const itemAnimation = {
    hidden: {
      y: 20,
      opacity: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };
  return (
    <motion.div
      className="heat"
      onClick={() => {
        const dataLayerArgs = {
          // dataLayer: {
          event: 'rbVideoTracking',
          event_name: 'video_sidebar',
          // eventCategory: 'video',
          video_sidebar: {
            value: `${category}::${heat.name}`,
            widget_type: `Knockout Tree - ${
              config.trackingTitle || config.navigationTitle
            }`
          }
          // eventAction: 'sidebar',
          // }
        };

        GAtrack(dataLayerArgs);

        setHeat(heat);
      }}
    >
      <motion.span
        variants={itemAnimation}
        animate="visible"
        className={`heat-bubble ${status}${
          activeHeat && heat.id === activeHeat.id ? ' active' : ''
        }`}
      >
        {heat.number}
      </motion.span>
    </motion.div>
  );
};

export { Heat };
